import React from 'react';

export default function PalmistryPhilosophy() {
  return (
    <section
      className="amm-palmistry101-section amm-palmistry101-philosophy-section"
      aria-labelledby="palmistry-why-heading"
    >
      <h2 id="palmistry-why-heading" className="amm-palmistry101-section-title">
        A More Grounded Way to Learn Palmistry
      </h2>
      <div className="amm-palmistry101-philosophy">
        <p>
          This is not fear-based fortune telling, and it is not rigid prediction language. The course teaches
          observation, pattern, and symbolic interpretation — the same patience you would bring to learning a
          map or a poem.
        </p>
        <p>
          The goal is clarity, not superstition. The hand is read as a living map of tendencies and chapters —
          not a sentence already written forever. When language stays careful, readings stay respectful.
        </p>
      </div>
    </section>
  );
}
